import http from '../../../utils/fetch';
export default {
    page(query) {
        return http({
            url: '/api/swyl/v1/demo/carePlanList/showPage',
            method: 'post',
            params: query
        });
    },
    selectPage(query) {
        return http({
            url: '/api/swyl/v1/demo/carePlanList/selectPage',
            method: 'post',
            params: query
        });
    },
    // saveTo(query) {
    //     return http({
    //         url: '/api/swyl/v1/demo/userCarePaodDifference/saveData',
    //         method: 'post',
    //         params: query
    //     });
    // },
    showPD() {
        return http({
            url: '/api/swyl/v1/demo/carePlanList/showPD',
            method: 'post',
        });
    },
    selectPD(time) {
        return http.post('/api/swyl/v1/demo/carePlanList/selectPD?time='+ time);
    },
    saveTo(entity) {
        return http.post('/api/swyl/v1/demo/carePlanList/saveData',entity);
    },
    subTo(entity) {
        return http.post('/api/swyl/v1/demo/carePlanList/submitData',entity);
    },
}